import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language-context";
import { ShieldCheck } from "lucide-react";
import { Link } from "wouter";

// Stripe checkout cancel_url (server subscription.service.ts). Unlike
// success.tsx, do not clear localStorage here: the member stays signed in.
export default function CancelPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-accent flex items-center justify-center">
          <ShieldCheck className="w-10 h-10 text-accent-foreground" />
        </div>
        <h1 className="font-serif text-4xl md:text-5xl font-medium mb-4">
          {t.cancel.title}
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto mb-8">
          {t.cancel.subtitle}
        </p>
        <Button asChild size="lg" data-testid="button-back-to-plans">
          <Link href="/plans">{t.cancel.backToPlans}</Link>
        </Button>
      </div>
    </div>
  );
}
